<div class="flex flex-1 flex-col gap-2">
  <dx-form
    [formData]="formData"
    [labelLocation]="'top'"
    [showColonAfterLabel]="false"
    (onFieldDataChanged)="onFieldDataChanged()"
    [colCount]="1"
    [readOnly]="readonly"
  >
    <dxi-item
      dataField="text"
      [label]="{ visible: false }"
      [editorOptions]="{ placeholder: 'Titolo' | transloco }"
    ></dxi-item>
  </dx-form>
</div>
